import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getDailyAttendance = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/DailyAttendance/get`,
      filter,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in getDailyAttendance:", error);
    return {
      data: [],
      isSuccess: false,
      message: error.message
    };
  }
};

export const saveDailyAttendance = async (model) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/DailyAttendance/save`,
      model,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in saveDailyAttendance:", error);
    return {
      success: false,
      message: error.message
    };
  }
};

export const getAbsentDaysForPayrollPeriod = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/DailyAttendance/getAbsentDaysForPayrollPeriod`,
      filter,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in getAbsentDaysForPayrollPeriod:", error);
    return [];
  }
};